import _ from "lodash";

function char2utf16(char) {
  if (!char) return;
  return isNaN(char.codePointAt(0)) ? 0 : char.codePointAt(0);
}

export default function str2utf16(str) {
  if (!str) return;
  return _.chain(str)
    .split("")
    .map(char2utf16)
    .sum()
    .value();
}
